<template>
  <div
    v-for="(field, key) in fields"
    :key="key"
    class="input-block"
    :class="field.additionalClass || ''"
  >
    <label :for="key">
      {{ field.label }}
      <span v-if="field.required">*</span>
    </label>
    <input
      :id="key"
      v-model="field.value"
      :type="field.type"
      :class="{
        'input-error': field.error,
      }"
    />
    <div v-if="field.error" class="input-error text-xs text-red">
      {{ field.error }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  fields: Record<
    string,
    {
      value: string
      required: boolean
      label: string
      error: string | boolean
      type: string
      additionalClass?: string
    }
  >
}>()
</script>

<style lang="postcss" scoped>
.input-block {
  @apply flex flex-col gap-1 w-full col-span-2 md:col-span-1;

  label {
    @apply font-medium block text-sm;

    span {
      @apply text-red-500;
    }
  }

  input {
    @apply w-full border border-gray-200 rounded-md p-2 bg-white;

    &.input-error {
      @apply border-red-500;
    }
  }

  &--full {
    @apply col-span-2;
  }
}
</style>
